export default __webpack_public_path__ + "static/media/WeShoot-logo-extended-white.0a0eecf3.svg";